<template>
    <b-form @submit.prevent="getBlockedKKMs(formData)">
        <b-form-group :label="$t('kkm.kkmSfdNum')">
            <b-form-input v-model="formData.sfdNumber"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('kkm.status')">
            <b-form-select v-model="formData.status" :options="statusOptions" />
        </b-form-group>
        <b-form-row class="mx-0">
            <b-button type="submit" variant="success" class="ml-auto" :disabled="isDisabled">
                <magnify-icon title="" />&nbsp;{{ $t('general.search') }}
            </b-button>
        </b-form-row>
    </b-form>
</template>

<script>
/* eslint-disable */
export default {
    name: 'KkmBlockedSearchForm',
    props: {
        fetch: Function,
        offset: Number,
        pageSize: Number,
        setOffset: Function
    },
    data () {
        return {
            formData: {
                sfdNumber: null,
                status: null,
                offset: this.offset,
                pageSize: this.pageSize
            }
        }
    },
    computed: {
        isDisabled() {
            return this.$store.getters.isLoading
        },
        statusOptions() {
            return [
                { value: null, text: this.$t('general.select') },
                { value: 'CREATED', text: this.$t('kkm.statusShortName.CREATED') },
                { value: 'READY', text: this.$t('kkm.statusShortName.READY') },
                { value: 'WAIT_OFD', text: this.$t('kkm.statusShortName.WAIT_OFD') },
                { value: 'STOP', text: this.$t('kkm.statusShortName.STOP') },
                { value: 'CLOSED', text: this.$t('kkm.statusShortName.CLOSED') }
            ]
        }
    },
    methods: {
        getBlockedKKMs(formData) {
            if (this.offset !== 0) {
                this.setOffset(0)
            } else {
                this.fetch(formData)
            }
        }
    },
    watch: {
        offset (newValue) {
            this.formData.offset = newValue
            this.fetch(this.formData)
        }
    }
}
</script>
